import React from "react";
import { FormattedMessage } from "react-intl";
import defineMessages from "../../../../../../common/helpers/defineMessages";

import Icon from "../../../../../icon";

import { StyledNotEdited, Alert } from "./styles";

const messages = defineMessages({
    notEdited: {
        id: "test.taskCard.notEdited",
    },
});

const NotEdited = () => (
    <StyledNotEdited>
        <div>
            <Alert>
                <Icon i="alert" />
            </Alert>
            <FormattedMessage {...messages.notEdited} />
        </div>
    </StyledNotEdited>
);

export default NotEdited;
